<template lang="pug">
.form-work-with-us-wrap
  v-form.form-work-with-us(ref="form")
    v-select.form-field(
      v-model="shop",
      :items="shops",
      :rules="[rules.required]",
      name="shop",
      label="Loja",
      background-color="white",
      color="primary",
      outlined,
      dense
    )
    v-select.form-field(
      v-model="vacancy",
      :items="vacancies",
      :rules="[rules.required]",
      name="vacancy",
      label="Vaga desejada",
      background-color="white",
      color="primary",
      outlined,
      dense
    )
    v-text-field.form-field(
      :rules="[rules.required]",
      name="name",
      type="name",
      label="Nome",
      background-color="white",
      color="primary",
      outlined,
      dense
    )
    v-text-field.form-field(
      :rules="[rules.required, rules.email]",
      color="primary",
      name="email",
      type="email",
      label="E-mail",
      background-color="white",
      outlined,
      dense
    )
    v-text-field.form-field.form-field--full(
      v-mask="['(##) ####-####', '(##) #####-####']",
      :rules="[rules.required, rules.phone]",
      color="primary",
      outlined,
      dense,
      name="tel",
      type="tel",
      label="Telefone",
      background-color="white"
    )
    v-file-input.form-field.form-field--full(
      :rules="[rules.required]",
      color="primary",
      name="attachment",
      label="Anexar currículo",
      background-color="white",
      accept=".doc,.docx,application/msword,application/pdf",
      outlined,
      dense
    )
    v-btn.form-field.form-field--full.secondary.white--text(
      @click="submit",
      large,
      depressed,
      block
    ) Enviar
    float-alert.form-field.form-field--full(:value="success", v-if="success", color="green") Sua mensagem foi enviada com sucesso.
    float-alert.form-field.form-field--full(:value="error", v-if="error", color="green") Aconteceu um erro ao enviar a mensagem.
  v-overlay(:value="loading")
    v-progress-circular(indeterminate, size="64")
</template>

<script>
import { mask } from "vue-the-mask";
import FloatAlert from "@/components/tools/FloatAlert";
import { required, email, phone } from "./rules";

export default {
  props: {
    action: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    shop: null,
    vacancy: null,
    rules: {
      required,
      email,
      phone,
    },
    loading: false,
    error: false,
    success: false,
  }),
  methods: {
    applyRouteSelection() {
      const { loja, vaga } = this.$route.query;

      if (loja) {
        const shop = this.shops.find(({ id }) => id == loja);
        if (shop) this.shop = shop.value;
      }

      if (vaga) {
        const vacancy = this.vacancies.find(({ id }) => id == vaga);
        if (vacancy) this.vacancy = vacancy.value;
      }
    },
    submit() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        this.error = false;
        this.success = false;

        fetch(this.action, {
          method: "POST",
          body: new FormData(this.$refs.form.$el),
        })
          .then((r) => {
            if (r.ok) this.success = true;
            else throw new Error(r.status);
          })
          .catch(() => (this.error = true))
          .finally(() => (this.loading = false));
      }
    },
  },
  computed: {
    shops() {
      return this.$rest("shops").list.map(({ id, title }) => ({
        text: title,
        value: title,
        id,
      }));
    },
    vacancies() {
      return this.$rest("vacancies").list.map(({ id, title }) => ({
        text: title,
        value: title,
        id,
      }));
    },
  },
  watch: {
    "$route.query"() {
      this.applyRouteSelection();
    },
    shops() {
      this.applyRouteSelection();
    },
    vacancies() {
      this.applyRouteSelection();
    },
  },
  directives: {
    mask,
  },
  beforeCreate() {
    this.$rest("shops").get();
    this.$rest("vacancies").get();
  },
  components: {
    FloatAlert,
  },
};
</script>

<style>
.form-work-with-us-wrap {
  width: 100%;
  max-width: 720px;
  margin: 0 auto;
}
.form-work-with-us {
  width: 100%;
  display: grid;
  grid-template-columns: 1fr;
  gap: 4px 16px;
  box-sizing: border-box;
  text-align: left;
  border-radius: 7px;
}
.form-work-with-us .form-field {
  width: 100%;
  margin-top: 0;
  padding-top: 0;
}
@media screen and (min-width: 960px) {
  .form-work-with-us {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .form-work-with-us .form-field--full {
    grid-column: 1 / -1;
  }
}
.form-work-with-us .v-alert {
  margin-top: 16px;
  font-size: 18px;
}
</style>
